import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchPerformanceCampaignCardsRequest } from "../../../redux/actions/performanceActions";
import "../PerformanceStyles.css";
import { sortCampaignsByDefault } from "../Collaborateur/performanceUi";

export default function PerformanceManagerCampaignList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data, loading, error } = useSelector((state) => state.performance.campaignCards);
    const campaigns = sortCampaignsByDefault(data);

    useEffect(() => {
        dispatch(fetchPerformanceCampaignCardsRequest());
    }, [dispatch]);

    useEffect(() => {
        if (!loading && !error && campaigns.length > 0) {
            navigate(`/performance/manager/campagnes/${campaigns[0].campagneId}/collaborateurs`, { replace: true });
        }
    }, [campaigns, error, loading, navigate]);

    return (
        <main className="perf-page">
            <header className="perf-header">
                <div>
                    <h1>Campagnes manager</h1>
                    <p>Suivi des campagnes performance de votre equipe.</p>
                </div>
            </header>
            {loading && <div className="perf-state">Chargement des campagnes...</div>}
            {error && <div className="perf-state perf-state--error">{error}</div>}
            {!loading && !error && campaigns.length === 0 && <div className="perf-state">Aucune campagne disponible.</div>}
            {!loading && !error && campaigns.length > 0 && <div className="perf-state">Ouverture de la campagne...</div>}
        </main>
    );
}
